import { CheckCircle, CreditCard, X } from 'lucide-react';
import { useState } from 'react';
import { useVerifyBankDetails } from '../hooks/useVerifyBankDetails';

const BankVerificationModal = ({ isOpen, onClose, seller }) => {
  const [isVerified, setIsVerified] = useState(seller?.bankDetails?.isVerified || false);
  const [note, setNote] = useState('');
  const { mutate: verifyBank, isPending } = useVerifyBankDetails();

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    verifyBank(
      { sellerId: seller._id },
      {
        onSuccess: () => {
          onClose();
          setNote('');
        },
      }
    );
  };

  return (
    <div className='fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm'>
      <div className='bg-card border border-border rounded-lg shadow-lg w-full max-w-2xl mx-4'>
        {/* Header */}
        <div className='flex items-center justify-between p-6 border-b border-border'>
          <h2 className='text-lg font-semibold text-foreground flex items-center'>
            <CreditCard className='mr-2' size={20} />
            Bank Details Verification
          </h2>
          <button
            onClick={onClose}
            className='text-muted-foreground hover:text-foreground transition-colors'
            disabled={isPending}
          >
            <X size={20} />
          </button>
        </div>

        {/* Content */}
        <form onSubmit={handleSubmit} className='p-6 space-y-6'>
          {/* Bank Details Summary */}
          <div className='bg-accent/50 rounded-lg p-4 space-y-3'>
            <h3 className='font-medium text-sm text-foreground mb-3'>Bank Account Information</h3>
            <div className='grid grid-cols-1 md:grid-cols-2 gap-3'>
              <div>
                <label className='text-xs text-muted-foreground'>Account Holder Name</label>
                <p className='text-sm font-medium'>{seller?.bankDetails?.accountHolderName || 'N/A'}</p>
              </div>
              <div>
                <label className='text-xs text-muted-foreground'>Account Number</label>
                <p className='text-sm font-medium'>{seller?.bankDetails?.accountNumber || 'N/A'}</p>
              </div>
              <div>
                <label className='text-xs text-muted-foreground'>IFSC Code</label>
                <p className='text-sm font-medium'>{seller?.bankDetails?.ifscCode || 'N/A'}</p>
              </div>
              <div>
                <label className='text-xs text-muted-foreground'>Bank Name</label>
                <p className='text-sm font-medium'>{seller?.bankDetails?.bankName || 'N/A'}</p>
              </div>
              {/* <div>
                <label className='text-xs text-muted-foreground'>Branch Name</label>
                <p className='text-sm font-medium'>{seller?.bankDetails?.branchName || 'N/A'}</p>
              </div> */}
              <div>
                <label className='text-xs text-muted-foreground'>UPI ID</label>
                <p className='text-sm font-medium'>{seller?.bankDetails?.upiId || 'N/A'}</p>
              </div>
            </div>
          </div>

          {/* Verification Status */}
          {/* <div>
            <label className='block text-sm font-medium text-foreground mb-3'>Verification Status</label>
            <div className='space-y-2'>
              <label className='flex items-center p-3 border border-border rounded-md cursor-pointer hover:bg-accent transition-colors'>
                <input
                  type='radio'
                  name='verified'
                  value='true'
                  checked={isVerified === true}
                  onChange={() => setIsVerified(true)}
                  className='mr-3'
                  required
                />
                <CheckCircle size={16} className='text-green-600 mr-2' />
                <div>
                  <div className='text-sm font-medium text-foreground'>Verified</div>
                  <div className='text-xs text-muted-foreground'>Bank details are verified and correct</div>
                </div>
              </label>
              <label className='flex items-center p-3 border border-border rounded-md cursor-pointer hover:bg-accent transition-colors'>
                <input
                  type='radio'
                  name='verified'
                  value='false'
                  checked={isVerified === false}
                  onChange={() => setIsVerified(false)}
                  className='mr-3'
                  required
                />
                <X size={16} className='text-red-600 mr-2' />
                <div>
                  <div className='text-sm font-medium text-foreground'>Not Verified</div>
                  <div className='text-xs text-muted-foreground'>Bank details need verification or correction</div>
                </div>
              </label>
            </div>
          </div> */}

          {/* Note */}
          {/* <div>
            <label htmlFor='note' className='block text-sm font-medium text-foreground mb-2'>
              Note (Optional)
            </label>
            <textarea
              id='note'
              value={note}
              onChange={(e) => setNote(e.target.value)}
              rows={3}
              className='w-full px-3 py-2 text-sm border border-border rounded-md bg-background focus:outline-none focus:ring-2 focus:ring-primary'
              placeholder='Add any additional notes about the verification...'
            />
          </div> */}

          {/* Footer */}
          <div className='flex justify-end gap-3 pt-4'>
            <button
              type='button'
              onClick={onClose}
              className='px-4 py-2 text-sm border border-border rounded-md bg-card hover:bg-accent transition-colors'
              disabled={isPending}
            >
              Cancel
            </button>
            <button
              type='submit'
              disabled={isPending}
              className='px-4 py-2 text-sm bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed'
            >
              {isPending ? 'Verifying...' : 'Submit Verification'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default BankVerificationModal;
